import { IApplicationState } from '../types/redux';

export const gaLabelSelector = (state: IApplicationState) => {
  return state.newbuilding.gaLabel;
};
